import React from 'react';
import './OfferTitle.less';

export const OfferTitle = ({text}) => {
	return <span className="offer-title">{text}</span>
}
